import { useState } from "react";

const SafeImage = ({ src, alt, style, className, onClick }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={className}
        onClick={onClick}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f0f0f0",
          color: "#aaa",
        }}
      >
        <i className="fa-regular fa-image" style={{ fontSize: 24 }} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onClick={onClick}
      onError={() => setFailed(true)}
    />
  );
};

export default SafeImage;
